/**
 * PENDING-TASKS
 * Taches de fond, en bas a droite de l'ecran : le hibou tourne avec le temps ecoule tant que la tache
 * s'execute, puis "Continuer" ouvre son resultat. Composant d'affichage : le suivi et l'ouverture des
 * taches restent a l'appelant.
 */
import Button from "@/components/button"
import ListButton from "@/components/list-button"
import { faTimes, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"

interface PendingTasksItem {
  id: string
  name: string
  status: "pending" | "done" | "error"
  createdAt: string
}

interface Props {
  tasks: PendingTasksItem[]
  doneText?: string //Texte d'une tache terminee
  onContinue: (task: PendingTasksItem) => void
  onRemove: (task: PendingTasksItem) => void //Annule une tache en cours, ou retire une tache en erreur
}

export default function PendingTasks({ tasks, doneText = "Traitement terminé.", onContinue, onRemove }: Props) {
  //Heure courante, pour le temps ecoule des taches en cours
  const [now, setNow] = useState(Date.now())
  const isRunning = tasks.some((task) => task.status === "pending")

  useEffect(() => {
    if (!isRunning) return
    const interval = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(interval)
  }, [isRunning])

  function getText(task: PendingTasksItem) {
    if (task.status === "pending") {
      const seconds = Math.max(0, Math.floor((now - new Date(task.createdAt).getTime()) / 1000))
      return `Traitement en cours… ${Math.floor(seconds / 60)} min ${seconds % 60} s`
    }
    if (task.status === "done") return doneText
    return "Le traitement a échoué"
  }

  if (!tasks.length) return null

  return (
    <div className="fixed bottom-20 right-20 z-50 flex w-[340px] flex-col gap-10">
      {tasks.map((task) => (
        <div
          key={task.id}
          className="flex items-center gap-10 rounded-[12px] bg-white px-[16px] py-[10px] shadow-custom">
          <img
            alt="owl"
            src={require("@/assets/owl.png")}
            className={`h-[40px] w-[40px] shrink-0 object-contain ${
              task.status === "pending" ? "animate-[spin_3s_linear_infinite]" : ""
            }`}
          />
          <div className="min-w-0 flex-1">
            <div className="truncate text-sm font-bold">{task.name}</div>
            <div className="grey-t text-sm">{getText(task)}</div>
          </div>
          {task.status === "done" ? (
            <Button className="primary" onClick={() => onContinue(task)}>
              Continuer
            </Button>
          ) : (
            <>
              {task.status === "error" && (
                <FontAwesomeIcon icon={faTriangleExclamation} className="red-t text-[20px]" />
              )}
              <ListButton
                icon={faTimes}
                text={task.status === "pending" ? "Annuler le traitement" : "Retirer"}
                onClick={() => onRemove(task)}
              />
            </>
          )}
        </div>
      ))}
    </div>
  )
}
